import { staffHomeTrendsSchema } from "@lafayette/schemas";
import { createMemoryTransport, } from "./memory-transport";
export function createStaffHomeTrendsApi(options) {
    const send = createMemoryTransport(options);
    return {
        trends: (callOptions) => send({
            method: "GET",
            path: "/staff/home-trends",
            schema: staffHomeTrendsSchema,
            signal: callOptions?.signal,
        }),
    };
}
